"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createThemeConfig = void 0;
var _merge = _interopRequireDefault(require("lodash/merge"));
var _themeDefaults = require("./themeDefaults");
var _getDomainTheme = require("./getDomainTheme");
var createThemeConfig = function createThemeConfig(themeName, themeConfig) {
  var domainTheme = (0, _getDomainTheme.getDomainTheme)(themeName);
  var themeVariant;
  var themeConfigName;
  if (domainTheme) {
    themeConfigName = domainTheme.name;
    themeVariant = domainTheme.theme;
  }
  if (themeConfig && themeConfig.themeName) {
    themeConfigName = themeConfig.themeName;
  }
  var mergedTheme = (0, _merge["default"])({}, _themeDefaults.themeDefaults, themeVariant, themeConfig);
  return {
    themeName: themeConfigName,
    theme: mergedTheme.theme,
    themeCss: mergedTheme.css
  };
};
exports.createThemeConfig = createThemeConfig;